import axios from "../plugins/parseAxios";

export class DigitalMeterLogApi {
  static getDigitalMeterLogBetweenDateByMarket(payload) {
    return axios.post("functions/getDigitalMeterLogBetweenDateByMarket", { 
      marketId : payload.marketId ,
      startDate : payload.startDate,
      endDate : payload.endDate
    });
  }
}